import { Brand } from "../../components/Brand";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Field } from "../../components/ui";
import { useAuth } from "./AuthProvider";

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email.trim(), password);
      navigate("/portfolios", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Échec de connexion");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <Brand className="login-brand" />
        <Field
          label="Email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Field
          label="Mot de passe"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <p className="error-text">{error}</p>}
        <Button type="submit" disabled={busy}>
          {busy ? "Connexion…" : "Se connecter"}
        </Button>
        <nav className="auth-links">
          <Link to="/register">Créer un compte</Link>
          <Link to="/forgot-password">Mot de passe oublié ?</Link>
        </nav>
      </form>
    </div>
  );
}
